import React, { useState, useEffect } from "react";
import {
    Box, Button, TextField, Typography, Grid, IconButton,
    Divider, Paper, Tooltip, Dialog, DialogTitle, DialogContent,
    DialogActions, CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const ViewToVerifySoOlympiad = ({ closePopup, modalData }) => {
    const [oldData, setOldData] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [verifyingId, setVerifyingId] = useState(null);
    const [attachmentMap, setAttachmentMap] = useState({});
const [verifyModal, setVerifyModal] = useState({
  open: false,
  item: null,
  remark: "",
  remarkError: "",
  submitting: false,
});
    const [disputeModal, setDisputeModal] = useState({
        open: false,
        entryId: null,
        item: null,
        remark: "",
        remarkError: "",
        submitting: false,
    });

    // ================= GET OLD DATA =================
    useEffect(() => {
        if (modalData?.regId) getOldData();
    }, [modalData?.regId]);

    const getOldData = async () => {
        try {
            if (!modalData?.regId) return;
            setHistoryLoading(true);
            const result = await window.Platform.database.getSOBOforOlympiadByRegId({
                regId: modalData.regId,
            });
            setOldData(result?.status ? result?.data || [] : []);
        } catch (error) {
            console.log(error);
            setOldData([]);
        } finally {
            setHistoryLoading(false);
        }
    };

    // const handleVerify = async (item) => {
    //     const isSuccess = window?.confirm("Are you sure to verify this SO")
    //     if(!isSuccess) return;
    //     try {
    //         setVerifyingId(item?.id);

    //         const result = await window.Platform.database.updateSOBOStatus({
    //             sobo_id: item?.id,
    //             action:"verify"
    //         });

    //         if (result?.status) {
    //             window.NotificationUtils.showSuccess(result?.message || "Entry verified successfully");
    //             // getOldData();
    //             closePopup()
    //         } else {
    //             window.NotificationUtils.showError(result?.message || "Something went wrong");
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         window.NotificationUtils.showError("Something went wrong");
    //     } finally {
    //         setVerifyingId(null);
    //     }
    // };

    const openVerifyModal = (item) => {
  setVerifyModal({ open: true, item, remark: "", remarkError: "", submitting: false });
};

const closeVerifyModal = () => {
  if (verifyModal.submitting) return;
  setVerifyModal({ open: false, item: null, remark: "", remarkError: "", submitting: false });
};

const handleVerifyRemarkChange = (e) => {
  const val = e.target.value;
  setVerifyModal((prev) => ({
    ...prev,
    remark: val,
    remarkError: val.trim().replace(/\s+/g, " ").length < 20
      ? `Remark must be at least 20 characters (${val.trim().replace(/\s+/g, " ").length}/20)`
      : "",
  }));
};

const handleVerifySubmit = async () => {
  const trimmed = verifyModal.remark.trim();
  if (!trimmed) {
    setVerifyModal((prev) => ({ ...prev, remarkError: "Remark is required" }));
    return;
  }
  if (trimmed.replace(/\s+/g, " ").length < 20) {
    setVerifyModal((prev) => ({
      ...prev,
      remarkError: `Remark must be at least 20 characters (${trimmed.replace(/\s+/g, " ").length}/20)`,
    }));
    return;
  }
  try {
    setVerifyModal((prev) => ({ ...prev, submitting: true }));
    setVerifyingId(verifyModal.item?.id);

    const result = await window.Platform.database.updateSOBOStatus({
      sobo_id: verifyModal.item?.id,
      action: "verify",
      verify_remark: trimmed,          // ← remark sent to API
    });

    if (result?.status) {
      window.NotificationUtils.showSuccess(result?.message || "Entry verified successfully");
      closeVerifyModal();
      closePopup();
    } else {
      window.NotificationUtils.showError(result?.message || "Something went wrong");
      setVerifyModal((prev) => ({ ...prev, submitting: false }));
    }
  } catch (error) {
    console.log(error);
    window.NotificationUtils.showError("Something went wrong");
    setVerifyModal((prev) => ({ ...prev, submitting: false }));
  } finally {
    setVerifyingId(null);
  }
};

    const openDisputeModal = (item) => {
        setDisputeModal({
            open: true,
            entryId: item?.id,
            item,
            remark: "",
            remarkError: "",
            submitting: false,
        });
    };
    
  // ================= NEW FORM FILE UPLOAD =================
   // REMOVE these 3 functions entirely:
// handleFileUpload, handleRemoveAttachment, submitAttachment

// ADD these instead:
const handleFileUpload = (e, itemId) => {
    const files = Array.from(e.target.files);
    if (!files?.length) return;
    const mappedFiles = files.map((file) => ({
        file,
        name: file.name,
        type: file.type,
        preview: URL.createObjectURL(file),
    }));
    setAttachmentMap((prev) => ({
        ...prev,
        [itemId]: [...(prev[itemId] || []), ...mappedFiles],
    }));
    e.target.value = ""; // reset so same file can be re-picked
};

const handleRemoveAttachment = (itemId, indexToRemove) => {
    const isConfirm = window.confirm("Are you sure you want to remove this attachment?");
    if (!isConfirm) return;
    setAttachmentMap((prev) => ({
        ...prev,
        [itemId]: (prev[itemId] || []).filter((_, i) => i !== indexToRemove),
    }));
};

const submitAttachment = async (item) => {
    const files = attachmentMap[item?.id] || [];
    if (!files.length) return;

    const formPayload = new FormData();
    files.forEach((fileObj) => {
        if (fileObj?.file instanceof File) {
            formPayload.append("files", fileObj.file);
        }
    });
    formPayload.append("sobo_id", item?.id || "");

    const result = await window.Platform.database.updateStudyMaterialSOAttachment(formPayload);
    if (result?.status) {
        window.NotificationUtils.showSuccess(result?.message || "Added successfully");
        setAttachmentMap((prev) => ({ ...prev, [item?.id]: [] })); // clear only this item's files
        getOldData();
    } else {
        window.NotificationUtils.showError(result?.message || "Something went wrong");
    }
};


    const closeDisputeModal = () => {
        setDisputeModal({
            open: false,
            entryId: null,
            item: null,
            remark: "",
            remarkError: "",
            submitting: false,
        });
    };

    const handleDisputeRemarkChange = (e) => {
        const val = e.target.value;
        setDisputeModal((prev) => ({
            ...prev,
            remark: val,
            // clear error as soon as they type enough
            remarkError: val.trim().replace(/\s+/g, " ").length < 20
                ? `Remark must be at least 20 characters (${val.trim().replace(/\s+/g, " ").length}/20)`
                : "",
        }));
    };

    const handleDisputeSubmit = async () => {
        const trimmed = disputeModal.remark.trim();

        if (!trimmed) {
            setDisputeModal((prev) => ({
                ...prev,
                remarkError: "Remark is required",
            }));
            return;
        }

        if (trimmed.length < 20) {
            setDisputeModal((prev) => ({
                ...prev,
                remarkError: `Remark must be at least 20 characters (${trimmed.length}/20)`,
            }));
            return;
        }

        try {
            setDisputeModal((prev) => ({ ...prev, submitting: true }));

            const result = await window.Platform.database.updateSOBOStatus({
                sobo_id: disputeModal.entryId,
                action:"despute",
                despute_remark: trimmed
            });

            if (result?.status) {
                window.NotificationUtils.showSuccess(result?.message || "Discrepancy raised successfully");
                closeDisputeModal();
                // getOldData();
                closePopup();
            } else {
                window.NotificationUtils.showError(result?.message || "Something went wrong");
                setDisputeModal((prev) => ({ ...prev, submitting: false }));
            }
        } catch (error) {
            console.log(error);
            window.NotificationUtils.showError("Something went wrong");
            setDisputeModal((prev) => ({ ...prev, submitting: false }));
        }
    };

    // ================= ATTACHMENT GRID =================
    // const AttachmentGrid = ({ files, onRemove, height = "140px" }) => (
    //     <Box mt={2}>
    //         <Grid container spacing={2}>
    //             {files.map((att, index) => {
    //                 const src = att?.preview || att?.path || null;
    //                 const isImage =
    //                     att?.type?.startsWith("image") ||
    //                     /\.(jpg|jpeg|png|gif|webp)/i.test(att?.path || "");

    //                 return (
    //                     <Grid item xs={12} sm={6} md={3} key={index}>
    //                         <Paper
    //                             elevation={2}
    //                             sx={{
    //                                 p: 1,
    //                                 borderRadius: 2,
    //                                 position: "relative",
    //                                 overflow: "hidden",
    //                                 height: "100%",
    //                                 display: "flex",
    //                                 flexDirection: "column",
    //                             }}
    //                         >
    //                             {onRemove && (
    //                                 <Tooltip title="Remove">
    //                                     <IconButton
    //                                         size="small"
    //                                         onClick={() => onRemove(index)}
    //                                         sx={{ position: "absolute", top: 5, right: 5, zIndex: 2, background: "#fff" }}
    //                                     >
    //                                         <DeleteIcon fontSize="small" color="error" />
    //                                     </IconButton>
    //                                 </Tooltip>
    //                             )}

    //                             {att?.path && (
    //                                 <Tooltip title="Preview">
    //                                     <IconButton
    //                                         size="small"
    //                                         onClick={() => setPreviewImage(att.path)}
    //                                         sx={{ position: "absolute", top: 5, left: 5, zIndex: 2, background: "#fff" }}
    //                                     >
    //                                         <ZoomInIcon fontSize="small" color="primary" />
    //                                     </IconButton>
    //                                 </Tooltip>
    //                             )}

    //                             {isImage ? (
    //                                 <img
    //                                     src={src}
    //                                     alt={att?.originalName || att?.name || "attachment"}
    //                                     onClick={() => src && setPreviewImage(src)}
    //                                     style={{
    //                                         width: "100%",
    //                                         height,
    //                                         objectFit: "cover",
    //                                         borderRadius: "8px",
    //                                         cursor: "pointer",
    //                                     }}
    //                                 />
    //                             ) : (
    //                                 <Box
    //                                     sx={{
    //                                         height,
    //                                         display: "flex",
    //                                         alignItems: "center",
    //                                         justifyContent: "center",
    //                                         background: "#f5f5f5",
    //                                         borderRadius: "8px",
    //                                     }}
    //                                 >
    //                                     <ImageIcon sx={{ fontSize: 50, color: "#999" }} />
    //                                 </Box>
    //                             )}

    //                             <Typography
    //                                 variant="caption"
    //                                 sx={{ mt: 1, display: "block", textAlign: "center", wordBreak: "break-word" }}
    //                             >
    //                                 {att?.originalName || att?.name || att?.fileName || "File"}
    //                             </Typography>
    //                         </Paper>
    //                     </Grid>
    //                 );
    //             })}
    //         </Grid>
    //     </Box>
    // );
const AttachmentGrid = ({ files, onRemove, height = "140px" }) => (
    <Box mt={2}>
        <Grid container spacing={2}>
            {files.map((att, index) => {
                const src = att?.preview || att?.path || null;

                const isImage =
                    att?.type?.startsWith("image") ||
                    /\.(jpg|jpeg|png|gif|webp)/i.test(att?.path || "");

                const isPdf =
                    att?.type === "application/pdf" ||
                    /\.pdf$/i.test(att?.path || att?.name || "");

                return (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Paper
                            elevation={2}
                            sx={{
                                p: 1,
                                borderRadius: 2,
                                position: "relative",
                                overflow: "hidden",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {onRemove && (
                                <Tooltip title="Remove">
                                    <IconButton
                                        size="small"
                                        onClick={() => onRemove(index)}
                                        sx={{ position: "absolute", top: 5, right: 5, zIndex: 2, background: "#fff" }}
                                    >
                                        <DeleteIcon fontSize="small" color="error" />
                                    </IconButton>
                                </Tooltip>
                            )}

                            {/* Zoom for images | Open for PDFs */}
                            {att?.path && (
                                <Tooltip title={isPdf ? "Open PDF" : "Preview"}>
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            isPdf
                                                ? window.open(att.path, "_blank")
                                                : setPreviewImage(att.path)
                                        }
                                        sx={{ position: "absolute", top: 5, left: 5, zIndex: 2, background: "#fff" }}
                                    >
                                        {isPdf
                                            ? <PictureAsPdfIcon fontSize="small" color="error" />
                                            : <ZoomInIcon fontSize="small" color="primary" />
                                        }
                                    </IconButton>
                                </Tooltip>
                            )}

                            {isImage ? (
                                <img
                                    src={src}
                                    alt={att?.originalName || att?.name || "attachment"}
                                    onClick={() => src && setPreviewImage(src)}
                                    style={{
                                        width: "100%",
                                        height,
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                    }}
                                />
                            ) : isPdf ? (
                                src?.startsWith("blob:") ? (
                                    // local newly selected PDF → iframe preview
                                    <Box
                                        sx={{ height, borderRadius: "8px", overflow: "hidden", cursor: "pointer" }}
                                        onClick={() => window.open(src, "_blank")}
                                    >
                                        <iframe
                                            src={src}
                                            title={att?.name || "PDF"}
                                            style={{ width: "100%", height: "100%", border: "none", pointerEvents: "none" }}
                                        />
                                    </Box>
                                ) : (
                                    // server PDF → icon + click to open
                                    <Box
                                        onClick={() => att?.path && window.open(att.path, "_blank")}
                                        sx={{
                                            height,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "#fff3f3",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            border: "1px solid #ffcccc",
                                        }}
                                    >
                                        <PictureAsPdfIcon sx={{ fontSize: 50, color: "#e53935" }} />
                                        <Typography variant="caption" sx={{ color: "#e53935", mt: 0.5, fontWeight: 600 }}>
                                            Open PDF
                                        </Typography>
                                    </Box>
                                )
                            ) : (
                                // other files (doc, xls, etc.)
                                <Box
                                    sx={{
                                        height,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "#f5f5f5",
                                        borderRadius: "8px",
                                    }}
                                >
                                    <ImageIcon sx={{ fontSize: 50, color: "#999" }} />
                                    <Typography variant="caption" sx={{ color: "#999", mt: 0.5 }}>
                                        {att?.name?.split(".").pop()?.toUpperCase() || "File"}
                                    </Typography>
                                </Box>
                            )}

                            <Typography
                                variant="caption"
                                sx={{ mt: 1, display: "block", textAlign: "center", wordBreak: "break-word" }}
                            >
                                {att?.originalName || att?.name || att?.fileName || "File"}
                            </Typography>
                        </Paper>
                    </Grid>
                );
            })}
        </Grid>
    </Box>
);
    // ================= IMAGE FULLSCREEN PREVIEW =================
    const ImagePreviewOverlay = () =>
        previewImage ? (
            <Box
                onClick={() => setPreviewImage(null)}
                sx={{
                    position: "fixed",
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(0,0,0,0.85)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "zoom-out",
                }}
            >
                <IconButton
                    onClick={() => setPreviewImage(null)}
                    sx={{ position: "absolute", top: 16, right: 16, color: "#fff" }}
                >
                    <CloseIcon />
                </IconButton>
                <img
                    src={previewImage}
                    alt="preview"
                    style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: 8, objectFit: "contain" }}
                />
            </Box>
        ) : null;

    // ================= RENDER =================
    return (
        <Box p={2} position="relative">
            <ImagePreviewOverlay />

            <Typography variant="h5" mb={2}>Verify SO</Typography>

            <Typography>
                <span style={{ fontSize: "16px", color: "#000" }}>RNO ID: {modalData?.rno_id}</span> |
                <span style={{ fontSize: "16px", color: "#000", marginLeft: "10px" }}>RM Name: {modalData?.userName}</span> |
                <span style={{ fontSize: "16px", color: "#000", marginLeft: "10px" }}>
                    Party Name: {modalData?.schoolName} ({modalData?.partyId})
                </span>
            </Typography>

            <IconButton
                aria-label="close"
                onClick={closePopup}
                sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}
            >
                <CloseIcon />
            </IconButton>

            <Divider sx={{ my: 2, width: "100%", opacity: 1, borderTop: "1px solid #000" }} />

            {/* ================= ENTRIES ================= */}
            {historyLoading ? (
                <Box textAlign="center" py={4}>
                    <CircularProgress />
                </Box>
            ) : (
                oldData?.map((item, index) => {
                    const displayIndex = oldData.length - index;
                    const existingImages = item?.study_materia_so_attachment || [];
                    const isVerifying = verifyingId === item?.id;
                    const isDisabled = item?.so_dispute == 1 || item?.so_verify == 1;

                    return (
                        <Paper
                            key={item?.id}
                            elevation={2}
                            sx={{ p: 2, mb: 3, background: "#f5f5f5" }}
                        >
                            <Typography variant="h6" mb={2} fontWeight={700}>
                                {/* Added Entry {index + 1} */}
                                    Entry {displayIndex}
                            </Typography>

                            {/* Fields */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth disabled
                                        label="Study Material Invoice No"
                                        value={item?.study_material_so_no || ""}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth disabled
                                        label="Study Material Amount"
                                        value={item?.study_material_so_amount || ""}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth disabled
                                        type="date"
                                        label="Study Material Invoice Date"
                                        value={
                                            item?.study_material_so_date
                                                ? new Date(item?.study_material_so_date).toLocaleDateString("en-CA")
                                                : ""
                                        }
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
    <Box display="flex" alignItems="center" gap={2}>
        <Button
            variant="outlined"
            component="label"
            startIcon={<UploadFileIcon />}
        >
            Upload Attachment
            <input
                hidden
                multiple
                type="file"
                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                onChange={(e) => handleFileUpload(e, item?.id)}
            />
        </Button>
        {(attachmentMap[item?.id] || []).length > 0 && (
            <Button
                variant="contained"
                color="success"
                size="small"
                onClick={() => submitAttachment(item)}
            >
                Submit
            </Button>
        )}
    </Box>
    {(attachmentMap[item?.id] || []).length > 0 && (
        <AttachmentGrid
            files={attachmentMap[item?.id]}
            onRemove={(index) => handleRemoveAttachment(item?.id, index)}
            height="140px"
        />
    )}
</Grid>
                            </Grid>

                            {/* Images */}
                            {existingImages.length > 0 && (
                                <Box mt={3}>
                                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                        Uploaded Images
                                    </Typography>
                                    <AttachmentGrid
                                        files={existingImages}
                                        onRemove={null}
                                        height="180px"
                                    />
                                </Box>
                            )}

                            {/* Action Buttons */}
                            {isDisabled ? 
                            // <span className="mt-3">
                            //     Add SO Remark : <span style={{color:"#1a29d4"}}> {item?.remark} </span>

                            //     Discrepancy Remark : <span style={{color:"#ff0000"}}> {item?.despute_remark} </span>

                            // </span>
                             <Box className="mt-3">
                                                            <Typography variant="subtitle2" fontSize={14} fontWeight={600} mb={1}>
                                                                 Add SO Remark : <span style={{color:"#1a29d4"}}> {item?.remark} </span>
                                                            </Typography>
                                                            <Typography variant="subtitle2" fontSize={14} fontWeight={600} mb={1}>
                                                               Discrepancy Remark : <span style={{color:"#ff0000"}}> {item?.despute_remark} </span>
                                                            </Typography>
                                                        </Box>
                            
                            :
                            <>
                            <Box  gap={1} mt={1}>
                                  <span>
                                Add SO Remark : <span style={{color:"#1a29d4"}}> {item?.remark} </span>
                            </span>
                            </Box>
                            <Box display="flex" justifyContent="space-between" gap={2} mt={3}>
                                {/* <Button
                                    fullWidth
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    startIcon={
                                        isVerifying
                                            ? <CircularProgress size={16} color="inherit" />
                                            : <CheckCircleOutlineIcon />
                                    }
                                    onClick={() => handleVerify(item)}
                                    disabled={item?.so_verify == 1 || item?.so_dispute == 1}
                                >
                                    {isVerifying ? "Verifying..." : "Verify"}
                                </Button> */}
                                <Button
  fullWidth
  variant="contained"
  color="success"
  size="small"
  startIcon={<CheckCircleOutlineIcon />}
  onClick={() => openVerifyModal(item)}          // ← open modal instead
  disabled={item?.so_verify == 1 || item?.so_dispute == 1}
>
  Verify
</Button>

                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="error"
                                    size="small"
                                    startIcon={<ErrorOutlineIcon />}
                                    onClick={() => openDisputeModal(item)}
                                    disabled={isVerifying}
                                >
                                    Discrepancy
                                </Button>
                            </Box></>
                            }
                        </Paper>
                    );
                })
            )}

            <Dialog
                open={disputeModal.open}
                onClose={!disputeModal.submitting ? closeDisputeModal : undefined}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 700 }}>
                    Raise Discrepancy

                    <IconButton
                        onClick={closeDisputeModal}
                        disabled={disputeModal.submitting}
                        sx={{ position: "absolute", right: 10, top: 10 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Please describe the issue clearly. Remark must be at least 20 characters.
                    </Typography>

                    <TextField
                        fullWidth
                        multiline
                        label="Remark *"
                        placeholder="Enter your Discrepancy remark here..."
                        value={disputeModal.remark}
                        onChange={handleDisputeRemarkChange}
                        error={!!disputeModal.remarkError}
                        // helperText={
                        //     disputeModal.remarkError ||
                        //     // `${disputeModal.remark.trim().length} characters entered`
                        //     `${disputeModal.remark.trim().replace(/\s+/g, " ").length} characters entered`
                        // }
                        // no maxRows / no inputProps maxLength → free size, no character limit
                        sx={{
                            "& .MuiInputBase-root": {
                                alignItems: "flex-start",
                                minHeight: "120px",
                            },
                        }}
                        disabled={disputeModal.submitting}
                    />
                </DialogContent>

                <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={closeDisputeModal}
                        disabled={disputeModal.submitting}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleDisputeSubmit}
                        disabled={disputeModal.submitting}
                        startIcon={
                            disputeModal.submitting
                                ? <CircularProgress size={16} color="inherit" />
                                : <ErrorOutlineIcon />
                        }
                    >
                        {disputeModal.submitting ? "Submitting..." : "Submit Discrepancy"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
  open={verifyModal.open}
  onClose={closeVerifyModal}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ fontWeight: 700 }}>
    Verify SO — Add Remark
    <IconButton
      onClick={closeVerifyModal}
      disabled={verifyModal.submitting}
      sx={{ position: "absolute", right: 10, top: 10 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <TextField
      fullWidth
      multiline
      label="Verify Remark *"
      placeholder="e.g. Invoice matched with physical copy, amount correct..."
      value={verifyModal.remark}
      onChange={handleVerifyRemarkChange}
      error={!!verifyModal.remarkError}
      helperText={verifyModal.remarkError || `${verifyModal.remark.trim().replace(/\s+/g, " ").length} characters entered`}
      disabled={verifyModal.submitting}
      sx={{
        "& .MuiInputBase-root": {
          alignItems: "flex-start",
          minHeight: "120px",
        },
      }}
    />
  </DialogContent>

  <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
    <Button variant="outlined" onClick={closeVerifyModal} disabled={verifyModal.submitting}>
      Cancel
    </Button>
    <Button
      variant="contained"
      color="success"
      onClick={handleVerifySubmit}
      disabled={verifyModal.submitting}
      startIcon={
        verifyModal.submitting
          ? <CircularProgress size={16} color="inherit" />
          : <CheckCircleOutlineIcon />
      }
    >
      {verifyModal.submitting ? "Verifying..." : "Confirm Verify"}
    </Button>
  </DialogActions>
</Dialog>
        </Box>
    );
};

export default ViewToVerifySoOlympiad;